/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LabelButton/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LabelButton({
  children,
  viewPath = "/DesignSystem/LabelButton",
  marginLeft = 8,
  color = "#606060",
  text = "Deafult text"
  
}) {
  return (<React.Fragment
>
<span
  data-testid="LabelButton.Text"
  data-view-path={viewPath}
 style={{'--ml-1-1sQQR4': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--c-2-1sQQR4': color}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}